import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Heart } from "lucide-react";
import { Button } from "./ui/button";
import { nav, org } from "../mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/95 backdrop-blur-md shadow-soft py-2" : "bg-background/80 backdrop-blur-sm py-3"
      }`}
    >
      <div className="container-prc flex items-center justify-between">
        <div className="flex items-center gap-8">
        <Link to="/" className="flex items-center gap-2.5 group" onClick={() => setOpen(false)}>
          <img src={org.logo} alt={org.name} className="h-12 w-12 rounded-xl object-contain bg-white shadow-soft transition-transform group-hover:scale-105" />
          <span className="leading-tight max-w-[210px]">
            <span className="block font-display font-extrabold text-[15px] text-primary tracking-tight leading-snug">{org.shortName}</span>
            <span className="block text-[10px] font-semibold uppercase tracking-wider text-accent">{org.tagline}</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `nav-link text-sm font-semibold text-foreground/80 hover:text-primary ${isActive ? "active text-primary" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Button variant="ghost" className="font-semibold" onClick={() => navigate("/get-involved")}>Volunteer</Button>
          <Button className="btn-cta bg-accent hover:bg-accent/90 text-accent-foreground font-bold rounded-full px-6" onClick={() => navigate("/donate")}>
            <Heart className="h-4 w-4 mr-1.5" /> Donate
          </Button>
        </div>

        <button className="lg:hidden p-2 text-primary" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <div className="container-prc py-4 flex flex-col gap-1">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 px-3 rounded-xl font-semibold ${isActive ? "bg-secondary text-primary" : "text-foreground/80"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="flex gap-3 pt-3">
              <Button variant="outline" className="flex-1 font-semibold" onClick={() => { setOpen(false); navigate("/get-involved"); }}>Volunteer</Button>
              <Button className="flex-1 btn-cta bg-accent hover:bg-accent/90 text-accent-foreground font-bold" onClick={() => { setOpen(false); navigate("/donate"); }}>
                <Heart className="h-4 w-4 mr-1.5" /> Donate
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
